<div class="background">
  <div class="bar" [style.width.%]="percentage"></div>
  <div class="text">{{ display() }}% </div>
</div>